import { createReducer } from '@reduxjs/toolkit';
import { EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE } from './spotted-vehicles-types';
import {
  fetchSpottedVehiclesCsv,
  resetSpottedVehiclesReportCsv,
  startFetchingSpottedVehiclesCsv,
} from './spotted-vehicles-actions';
import { mapSpottedVehiclesReportToCsvRow } from './spotted-vehicles-utils';

export const exportSpottedVehicleReportCsvReducer = createReducer(
  EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE,
  (builder) => {
    builder.addCase(startFetchingSpottedVehiclesCsv.fulfilled, (state, action) => {
      return { ...state, total: action.payload };
    });

    builder.addCase(startFetchingSpottedVehiclesCsv.pending, (state) => {
      return { ...state, isLoading: true };
    });

    builder.addCase(fetchSpottedVehiclesCsv.fulfilled, (state, action) => {
      const csvArray = state.csvArray.concat(
        mapSpottedVehiclesReportToCsvRow(action.payload.records, action.payload.timezone),
      );
      const records = state.records.concat(action.payload.records);
      const progress = Math.round((records.length / state.total) * 100);
      return {
        ...state,
        isLoadingChunk: false,
        records,
        progress,
        isLoading: progress < 100,
        csvArray,
      };
    });

    builder.addCase(fetchSpottedVehiclesCsv.pending, (state) => {
      return { ...state, isLoadingChunk: true };
    });

    builder.addCase(resetSpottedVehiclesReportCsv, () => EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE);

    builder.addDefaultCase((state) => state);
  },
);
